import { Component, Inject, OnInit, EventEmitter, OnDestroy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-confirm',
  templateUrl: './dialog-confirm.component.html',
  styleUrls: ['./dialog-confirm.component.scss'],
})

export class DialogConfirmComponent implements OnInit, OnDestroy {
  loading: boolean = false;
  $handleBtnLeft = new EventEmitter();
  $handleBtnRight = new EventEmitter();

  constructor(private dialogRef: MatDialogRef<DialogConfirmComponent>, @Inject(MAT_DIALOG_DATA) public data) {}

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
     this.dialogRef = null
     this.$handleBtnLeft = null
     this.$handleBtnRight = null
  }

  handleBtnLeft() {
    this.$handleBtnLeft.emit(this.data.value);
    this.$handleBtnLeft.complete()
  }
  public setLoading(value) {
    this.loading = value;
  }

  handleBtnRight() {
    this.$handleBtnRight.emit(this.data.value);
    this.$handleBtnRight.complete()
  }

  close() {
    this.dialogRef.close();
  }
}
